import * as React from "react";
import Typography from "components/Typography";
import * as styles from "./styles";

interface IProps {
  email: string;
  firstName: string;
  lastName: string;
}

const User: React.FunctionComponent<IProps> = ({
  email,
  firstName,
  lastName
}) => {
  if (firstName && lastName) {
    return (
      <div className={styles.container}>
        <Typography type="headline" color={"black"}>
          {firstName} {lastName}
        </Typography>
        <Typography type="subheading" color="normal">
          ({email})
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Typography type="headline">{email}</Typography>
    </div>
  );
};

export default User;
